
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"556","height":"556","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M479.426 101.245c-49.215-56.224-121.5-91.754-202.019-91.754C129.264 9.49 8.991 129.764 8.991 277.907s120.273 268.416 268.416 268.416S545.823 426.05 545.823 277.907c0-67.624-25.061-129.442-66.397-176.662","stroke":"#0CA597","stroke-width":"6.84488","stroke-dasharray":"0, 1725","fill":"none"}}),_c('circle',{attrs:{"cx":"278","cy":"278","r":"235","stroke":"#FFF","stroke-width":"4","fill":"none"}})])
          )
        }
      }
    